import React, { useContext, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import ProveedoresScreen from "../../../../ERP/Compras/Proveedores/ProveedoresScreen";
import { getProveedor } from "../../../../../API/Compras/Proveedores/ProveedoresRequest";
import Loader from "../../../../../Base/Components/Loader/Loader";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import CrudProveedoresCAI from "../../../../ERP/Compras/Proveedores/ModalProveedores/CrudProveedoresCAI";
import { Dialog } from "primereact/dialog";

const OverlayPanelProveedores = () => {
  const fp = useRef(null);
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [proveedores, setProveedores] = useState("");
  const [selected, setSelected] = useState([]);
  const [showDialogCAI, setShowDialogCAI] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    const proveedor = await getProveedor();
    setProveedores(proveedor);
    setLoading(false);
  };

  const colums = [
    {
      field: "IdVendor",
      header: "ID",
      className: "Xsmall",
      frozen: true,
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "CodigoProveedor",
      header: "Código Proveedor",
      headerEn: "Supplier Code",
      className: "small",
      Sumary: "count",
      frozen: true,
    },
    {
      field: "CustomerName",
      header: "Nombre",
      headerEn: "Name",
      flex: 1,
      minWidth: 200,
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      className: "Xsmall",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "Contact",
      header: "Agente de Compras",
      headerEn: "Purchase Agent",
      className: "small",
      className: "large",
    },
    {
      field: "IdVendor",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-plus",
          tooltip: "Agregar CAI",
          onClick: (rowData) => {
            setShowDialogCAI(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: proveedores,
    loading: loading,
    key: "IdVendor",
  };

  const openOver = (e) => {
    fp?.current.toggle(e);
  };

  useEffect(() => {
    getInfo();
  }, []);

  return (
    <div>
      <Button icon="ri-folder-user-line" onClick={(e) => openOver(e)} tooltip="Agregar CAI"/>
      <Loader loading={loading} querySelector={"#Proveedores"} />
      <OverlayPanel
        dismissable={false}
        ref={fp}
        style={{ width: "50vw", height: "45vh" }}
        onHide={() => setIsOpen(false)}
        showCloseIcon
      >
        <div style={{ height: "45vh" }} id="Proveedores">
          <AgGrid table={table} />
        </div>

        <Dialog
          visible={showDialogCAI}
          onHide={() => setShowDialogCAI(false)}
          maximizable
          closeOnEscape={false}
        >
          <CrudProveedoresCAI
            selected={selected}
            showDialogCAI={showDialogCAI}
            setShowDialogCAI={setShowDialogCAI}
            proveedorSeleccionado={selected}
            actualizarProveedoresCAI={getInfo}
          />
        </Dialog>
      </OverlayPanel>
    </div>
  );
};

export default OverlayPanelProveedores;
